export default "__VITE_ASSET__C7g$wz$T__"